import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.tipoServicio.fields.id'),
  },
  {
    name: 'descripcion',
    label: i18n('entities.tipoServicio.fields.descripcion'),
  },
  {
    name: 'habilitado',
    label: i18n('entities.tipoServicio.fields.habilitado'),
    render: exporterRenders.boolean(),
  },
  {
    name: 'createdAt',
    label: i18n('entities.tipoServicio.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.tipoServicio.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
